const name = 'Ashish Raghute';
const role = 'Advisor';
const text = `Ashish Raghute is CIO and CIO-Advisor for Fortune 500 and offers Strategy Consulting at Big-5. He has a background as an engineer with an MBA.
He is also a Board Member at University of California for Design Thinking.`;

const ashishRaghute = { name, role, text };

export default ashishRaghute;
